import { createAsyncThunk } from '@reduxjs/toolkit';
import { _patientUrls } from '@custom/Utils/constants/apiUrls';

const deactivatePatientApi = createAsyncThunk('deactivatePatientApi', async (data: any) => {
    const pageLimit = data?.pgLimit || 30;
    const pageNumber = data?.pgNumber || 1;
    const offset = data?.pageNumber || 0;
    const hospitalId = data?.hospitalId || sessionStorage.getItem('hospitalId') || localStorage.getItem('hospitalId');
    const token = sessionStorage.getItem('token') || localStorage.getItem('token');
    const searchQ = data?.searchQ || '';

    try {
        let url = `${_patientUrls.deactivatePatient}?limit=${pageLimit}&offset=${offset}&patientID=${data?.patientId || ''}&hospitalId=${hospitalId}&searchQ=${encodeURIComponent(searchQ)}&fromDate=${data?.fromDate || ''}&endDate=${data?.endDate || ''}`;
        let response = await fetch(url, {
            method: 'GET',
            headers: {
                Authorization: `Bearer ${token}`,
            }
        });
        return await response.json();
    } catch (error) {
        return error;
    }
});

export default deactivatePatientApi;
